module.exports = __webpack_public_path__ + "img/ic_hubspot.dacb8a7e.png";